var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upload-document-wrapper",
      on: {
        dragover: _vm.dragover,
        dragleave: _vm.dragleave,
        drop: _vm.drop,
        click: function($event) {
          _vm.$refs.inputFile.click()
        }
      }
    },
    [
      _c("input", {
        ref: "inputFile",
        staticClass: "d-none",
        attrs: { type: "file" },
        on: { change: _vm.change }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-center h-100"
        },
        [
          _c("span", { staticClass: "mod-icon-upload" }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "upload-title" },
            [
              !_vm.addingFile
                ? [_vm._v("\n        Browse or drag to upload\n      ")]
                : [_vm._v("\n        " + _vm._s(_vm.progress) + "%\n      ")]
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4331906e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4331906e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/subcomponents/UploadDocument.vue
// module id = null
// module chunks = 